/* eslint-disable camelcase */
import React from 'react';
import { useMediaQuery } from '../../../../../../../../util/useMediaQuery';

import rightArrow from '../../../../../assets/images/chevron-right-grey.svg';
import rightArrowHover from '../../../../../assets/images/chevron-right-blue.svg';

import dropdown from '../../../../../assets/images/dropdown.svg';

import { DropdownButton, DropdownNavLink } from '../../PrimaryNavLinksStyles';

import {
  MegaMenuDropdown,
  SolutionsMegaMenuContainer,
  MegaMenuHr,
  MegaMenuAllLink,
  MegaMenuAllLinkA,
  MegaMenuArrow,
  MegaMenuColumns,
  NavTitle,
} from '../MegaMenuStyles';

import LargeIconLinks from '../atoms/LargeIconLinks';
import { HandleKeydown } from '../atoms';
import StyledMegamenuClose from '../atoms/MegamenuClose';
import { LazyLink } from '../../../../../../../../slices/atoms';

const SolutionsMegaMenu = (
  item,
  navigation,
  currentPath,
  openCurrentMegaMenu,
  closeMegaMenu,
  isMegaMenuOpen,
  currentMegaMenu,
) => {
  const { primary_navigation_text } = item;
  const { solutions_mega_menu, solutions_bottom_link, solutions_bottom_link_text } = navigation;

  const isMobile = useMediaQuery('(max-width: 1023px)');

  return (
    <>
      <DropdownButton
        onClick={() => {
          if (isMegaMenuOpen && currentMegaMenu === 'solutions') closeMegaMenu();
          openCurrentMegaMenu('solutions');
        }}
        className="nav-item"
        key={primary_navigation_text}
      >
        <DropdownNavLink
          role="button"
          tabIndex="0"
          aria-pressed="false"
          onKeyDown={e => {
            HandleKeydown(e);
          }}
          className={`${currentPath === 'solutions' && 'active'}`}
        >
          {primary_navigation_text}
        </DropdownNavLink>
        {!isMobile && <img className="dropdown" src={dropdown} />}
      </DropdownButton>

      {isMegaMenuOpen && currentMegaMenu === 'solutions' && !isMobile && (
        <MegaMenuDropdown id="solutionsMegaDropdown">
          <MegaMenuColumns className="solutions-columns"  flexDirection="column">
            <NavTitle className="solutions-title">Our Solutions</NavTitle>
            <SolutionsMegaMenuContainer size={12}>{LargeIconLinks(solutions_mega_menu)}</SolutionsMegaMenuContainer>
          </MegaMenuColumns>

          <MegaMenuHr />

          <MegaMenuAllLink className="solutions-link">
              <MegaMenuAllLinkA
                renderAs={LazyLink}
                url={solutions_bottom_link && solutions_bottom_link.url}
                url={solutions_bottom_link && solutions_bottom_link.url}
              >
                {solutions_bottom_link_text}
                {<MegaMenuArrow className="grey" src={rightArrow} alt="arrow" />}
                {<MegaMenuArrow className="blue" src={rightArrowHover} alt="arrow" />}
              </MegaMenuAllLinkA>
          </MegaMenuAllLink>
        </MegaMenuDropdown>
      )}

      {isMobile && (
        <MegaMenuDropdown id="solutionsMegaDropdown">
          <MegaMenuColumns className="solutions-columns" flexDirection="column">
            <NavTitle className="solutions-title">Our Solutions</NavTitle>
            <SolutionsMegaMenuContainer size={12}>{LargeIconLinks(solutions_mega_menu)}</SolutionsMegaMenuContainer>
          </MegaMenuColumns>

          <MegaMenuHr />

          <MegaMenuAllLink>
              <MegaMenuAllLinkA
                renderAs={LazyLink}
                url={solutions_bottom_link && solutions_bottom_link.url}
                url={solutions_bottom_link && solutions_bottom_link.url}
              >
                {solutions_bottom_link_text}
                {<MegaMenuArrow className="grey" src={rightArrow} alt="arrow" />}
                {<MegaMenuArrow className="blue" src={rightArrowHover} alt="arrow" />}
              </MegaMenuAllLinkA>
          </MegaMenuAllLink>
        </MegaMenuDropdown>
      )}

      {isMegaMenuOpen && !isMobile && <StyledMegamenuClose onClick={closeMegaMenu} />}
    </>
  );
};

export default SolutionsMegaMenu;
